// Originally generated from _docs/feature-catalog.csv (`npm run features:generate`
// — note the script still targets the FROZEN legacy src/lib/features/catalog.ts,
// not this package). This package copy has since gained manual additions
// (PLAN_CODES, user.journal.* granular keys) — keep the CSV in sync when editing.

import type { FeatureDefinition, PlanFeatureAccess } from "./types.js";

export const FEATURES: FeatureDefinition[] = [
  {
    key: "user.profile",
    scope: "user",
    category: "account",
    labelRo: "Profil si preferinte",
    labelEn: "Profile and preferences",
    type: "bool",
    status: "built",
  },
  {
    key: "user.family_members.max",
    scope: "user",
    category: "account",
    labelRo: "Conturi familie",
    labelEn: "Family member accounts",
    type: "quota",
    defaultLimit: 2,
    status: "built",
    notes: "Site actual: 5 pe Plus",
  },
  {
    key: "user.proxy_booking",
    scope: "user",
    category: "account",
    labelRo: "Programare pentru alt membru",
    labelEn: "Proxy booking for family member",
    type: "bool",
    status: "built",
  },
  {
    key: "user.history.retention_months",
    scope: "user",
    category: "account",
    labelRo: "Istoric consultatii/programari",
    labelEn: "History retention (months)",
    type: "quota",
    defaultLimit: 24,
    status: "built",
    notes: "Site actual: 12 luni free",
  },
  {
    key: "user.favorites.max",
    scope: "user",
    category: "account",
    labelRo: "Medici favoriti (bookmarks)",
    labelEn: "Favorite doctors (simple bookmarks)",
    type: "quota",
    defaultLimit: 3,
    status: "built",
    notes: "Diferit de colectii — simplu pin",
  },
  {
    key: "user.saved_searches.max",
    scope: "user",
    category: "account",
    labelRo: "Cautari salvate",
    labelEn: "Saved searches",
    type: "quota",
    defaultLimit: 5,
    status: "built",
  },
  {
    key: "user.saved_searches.alerts",
    scope: "user",
    category: "account",
    labelRo: "Alerte cautari (email/push la rezultat nou)",
    labelEn: "Alerts on saved searches (new match)",
    type: "bool",
    status: "planned",
    notes: "Plus only pe site",
  },
  {
    key: "user.collections.max",
    scope: "user",
    category: "account",
    labelRo: "Colectii (grupe cu adnotari)",
    labelEn: "Collections (groups with annotations)",
    type: "quota",
    defaultLimit: 10,
    status: "built",
    notes: "Grupe cu note/tags/pro-contra",
  },
  {
    key: "user.collections.items_per_collection.max",
    scope: "user",
    category: "account",
    labelRo: "Rezultate per colectie",
    labelEn: "Items per collection",
    type: "quota",
    defaultLimit: 5,
    status: "built",
    notes: "Site actual: 5 per colectie pe Free",
  },
  {
    key: "user.collections.annotations",
    scope: "user",
    category: "account",
    labelRo: "Note pro/contra si tags pe colectii",
    labelEn: "Collection annotations (notes/pro-contra/tags)",
    type: "bool",
    status: "planned",
    notes: "Plus only",
  },
  {
    key: "user.collections.sharing",
    scope: "user",
    category: "account",
    labelRo: "Partajare colectii cu familia/alti useri",
    labelEn: "Collection sharing",
    type: "bool",
    status: "planned",
    notes: "Plus only",
  },
  {
    key: "user.compare.results_max",
    scope: "user",
    category: "account",
    labelRo: "Comparare rezultate side-by-side",
    labelEn: "Compare results side-by-side",
    type: "quota",
    defaultLimit: 2,
    status: "built",
    notes: "Site: 2 free / 5 plus",
  },
  {
    key: "user.ads_free",
    scope: "user",
    category: "account",
    labelRo: "Fara reclame",
    labelEn: "Ad-free experience",
    type: "bool",
    status: "planned",
    notes: "Plus only",
  },
  {
    key: "user.punctuality_rewards",
    scope: "user",
    category: "account",
    labelRo: "Recompense punctualitate + badges",
    labelEn: "Punctuality rewards and badges",
    type: "bool",
    status: "planned",
    notes: "Plus only",
  },
  {
    key: "user.search.basic",
    scope: "user",
    category: "search",
    labelRo: "Cautare basic",
    labelEn: "Basic search (specialty+city)",
    type: "bool",
    status: "built",
  },
  {
    key: "user.search.filters_advanced",
    scope: "user",
    category: "search",
    labelRo: "Filtre avansate",
    labelEn: "Advanced filters (CAS/video/langs)",
    type: "bool",
    status: "built",
  },
  {
    key: "user.search.cross_border",
    scope: "user",
    category: "search",
    labelRo: "Cautare cross-country",
    labelEn: "Cross-country search",
    type: "bool",
    status: "built",
  },
  {
    key: "user.search.ai_semantic",
    scope: "user",
    category: "search",
    labelRo: "Cautare AI semantica",
    labelEn: "AI semantic search",
    type: "bool",
    status: "wip",
    notes: "Limbaj natural",
  },
  {
    key: "user.search.symptom_checker.per_month",
    scope: "user",
    category: "search",
    labelRo: "Symptom checker AI",
    labelEn: "AI symptom checker per month",
    type: "quota",
    defaultLimit: 5,
    status: "planned",
  },
  {
    key: "user.search.ai_medic_match",
    scope: "user",
    category: "search",
    labelRo: "AI Medic Match (recomandari simptome)",
    labelEn: "AI Medic Match (symptom-based recommendations)",
    type: "bool",
    status: "planned",
    notes: "Plus only",
  },
  {
    key: "user.search.voice",
    scope: "user",
    category: "search",
    labelRo: "Voice input",
    labelEn: "Voice search",
    type: "bool",
    status: "built",
  },
  {
    key: "user.book.standard",
    scope: "user",
    category: "booking",
    labelRo: "Programare standard",
    labelEn: "Standard booking",
    type: "bool",
    status: "built",
  },
  {
    key: "user.book.active_concurrent.max",
    scope: "user",
    category: "booking",
    labelRo: "Programari active simultan",
    labelEn: "Concurrent active bookings",
    type: "quota",
    defaultLimit: 3,
    status: "built",
    notes: "Site: 3 free / 10 plus",
  },
  {
    key: "user.book.waitlist",
    scope: "user",
    category: "booking",
    labelRo: "Waitlist pe slot",
    labelEn: "Slot waitlist",
    type: "bool",
    status: "built",
  },
  {
    key: "user.book.waitlist_autofill",
    scope: "user",
    category: "booking",
    labelRo: "Waitlist auto-fill + confirmare rapida",
    labelEn: "Waitlist auto-fill and quick confirm",
    type: "bool",
    status: "planned",
    notes: "Plus only",
  },
  {
    key: "user.book.reschedule_free.per_booking",
    scope: "user",
    category: "booking",
    labelRo: "Reprogramari gratuite per programare (>24h)",
    labelEn: "Free reschedules per booking (>24h)",
    type: "quota",
    defaultLimit: 0,
    status: "built",
    notes: "Site: 2x pe Plus",
  },
  {
    key: "user.book.recurring",
    scope: "user",
    category: "booking",
    labelRo: "Programari recurente",
    labelEn: "Recurring appointments",
    type: "bool",
    status: "planned",
  },
  {
    key: "user.book.family_scheduling",
    scope: "user",
    category: "booking",
    labelRo: "Scheduling multi-membru",
    labelEn: "Multi-member scheduling",
    type: "bool",
    status: "planned",
  },
  {
    key: "user.book.priority_slots",
    scope: "user",
    category: "booking",
    labelRo: "Slots rezervate premium",
    labelEn: "Premium priority slots",
    type: "bool",
    status: "idea",
  },
  {
    key: "user.vault.storage_mb",
    scope: "user",
    category: "medical_vault",
    labelRo: "Spatiu vault",
    labelEn: "Vault storage MB",
    type: "quota",
    defaultLimit: 100,
    status: "built",
  },
  {
    key: "user.vault.biometric_unlock",
    scope: "user",
    category: "medical_vault",
    labelRo: "Unlock biometric WebAuthn",
    labelEn: "Biometric unlock (WebAuthn/passkey)",
    type: "bool",
    status: "built",
    notes: "Recent",
  },
  {
    key: "user.vault.ai_extraction.per_month",
    scope: "user",
    category: "medical_vault",
    labelRo: "AI extract text din docs",
    labelEn: "AI text extraction from documents",
    type: "quota",
    defaultLimit: 5,
    status: "wip",
  },
  {
    key: "user.vault.ai_summary.per_month",
    scope: "user",
    category: "medical_vault",
    labelRo: "AI sumarizare istoric",
    labelEn: "AI history summary",
    type: "quota",
    defaultLimit: 0,
    status: "planned",
  },
  {
    key: "user.vault.share_with_doctor",
    scope: "user",
    category: "medical_vault",
    labelRo: "Share vault cu medic",
    labelEn: "Share with doctor on consult",
    type: "bool",
    status: "wip",
  },
  {
    key: "user.vault.fhir_export",
    scope: "user",
    category: "medical_vault",
    labelRo: "Pasaport medical (export FHIR/PDF)",
    labelEn: "Medical passport (FHIR/PDF export)",
    type: "bool",
    status: "planned",
    notes: "Plus only",
  },
  {
    key: "user.medical_journal",
    scope: "user",
    category: "medical_vault",
    labelRo: "Jurnal medical",
    labelEn: "Medical journal",
    type: "bool",
    status: "planned",
    notes: "Plus only",
  },
  {
    key: "user.journal.notes.per_month",
    scope: "user",
    category: "medical_vault",
    labelRo: "Note jurnal pe luna",
    labelEn: "Journal notes per month",
    type: "quota",
    defaultLimit: 10,
    status: "built",
    notes: "Legacy journalNotes: 10/luna free, nelimitat Plus",
  },
  {
    key: "user.journal.documents",
    scope: "user",
    category: "medical_vault",
    labelRo: "Documente in jurnal (doc/analize/imagistica)",
    labelEn: "Journal documents (document/lab/imaging entries)",
    type: "bool",
    status: "built",
    notes: "Legacy journalDocuments: Plus only",
  },
  {
    key: "user.journal.metrics",
    scope: "user",
    category: "medical_vault",
    labelRo: "Metrici sanatate in jurnal",
    labelEn: "Journal health metrics",
    type: "bool",
    status: "built",
    notes: "Legacy journalMetrics: Plus only",
  },
  {
    key: "user.journal.pin",
    scope: "user",
    category: "medical_vault",
    labelRo: "Fixare intrari jurnal",
    labelEn: "Pin journal entries",
    type: "bool",
    status: "built",
    notes: "Legacy journalPin: Plus only",
  },
  {
    key: "user.messaging_doctor",
    scope: "user",
    category: "communication",
    labelRo: "Chat cu medicul",
    labelEn: "Chat with booked doctor",
    type: "bool",
    status: "idea",
  },
  {
    key: "user.video_consult",
    scope: "user",
    category: "communication",
    labelRo: "Join video consult",
    labelEn: "Join video consultation",
    type: "bool",
    status: "wip",
    notes: "Infra exista",
  },
  {
    key: "user.calendar_sync",
    scope: "user",
    category: "communication",
    labelRo: "Calendar sync Google/Apple/Outlook",
    labelEn: "External calendar sync",
    type: "bool",
    status: "built",
  },
  {
    key: "user.health_calendar",
    scope: "user",
    category: "communication",
    labelRo: "Calendar sanatate (personal)",
    labelEn: "Personal health calendar",
    type: "bool",
    status: "planned",
    notes: "Plus only",
  },
  {
    key: "user.reminders_push",
    scope: "user",
    category: "communication",
    labelRo: "Remindere push (basic)",
    labelEn: "Basic push reminders",
    type: "bool",
    status: "built",
    notes: "Site: push free",
  },
  {
    key: "user.reminders_multichannel",
    scope: "user",
    category: "communication",
    labelRo: "Remindere multi-canal (Push+WA+Viber+SMS+Email)",
    labelEn: "Multichannel reminders (Push+WA+Viber+SMS+Email)",
    type: "bool",
    status: "built",
    notes: "Plus only pe site",
  },
  {
    key: "user.referral_wallet",
    scope: "user",
    category: "growth",
    labelRo: "Wallet cu recomandari",
    labelEn: "Referral wallet",
    type: "bool",
    status: "built",
  },
  {
    key: "user.challenges",
    scope: "user",
    category: "growth",
    labelRo: "Challenges + badges",
    labelEn: "Challenges and badges",
    type: "bool",
    status: "built",
  },
  {
    key: "user.post_reviews",
    scope: "user",
    category: "growth",
    labelRo: "Posteaza recenzii",
    labelEn: "Post reviews",
    type: "bool",
    status: "built",
  },
  {
    key: "user.ai_assistant_personal.per_month",
    scope: "user",
    category: "premium",
    labelRo: "AI asistent personal sanatate",
    labelEn: "Personal AI health assistant",
    type: "quota",
    defaultLimit: 0,
    status: "planned",
  },
  {
    key: "user.priority_support",
    scope: "user",
    category: "premium",
    labelRo: "Suport prioritar",
    labelEn: "Priority support",
    type: "bool",
    status: "idea",
  },
  {
    key: "user.early_access",
    scope: "user",
    category: "premium",
    labelRo: "Early access features",
    labelEn: "Early feature access",
    type: "bool",
    status: "idea",
  },
  {
    key: "provider.profile.basic",
    scope: "provider",
    category: "profile",
    labelRo: "Profil de baza",
    labelEn: "Basic profile",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.profile.branded_page",
    scope: "provider",
    category: "profile",
    labelRo: "Pagina branded custom",
    labelEn: "Custom branded page",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.profile.gallery.photos_max",
    scope: "provider",
    category: "profile",
    labelRo: "Fotografii in galerie",
    labelEn: "Gallery photos",
    type: "quota",
    defaultLimit: 1,
    status: "built",
  },
  {
    key: "provider.profile.seo_optimization",
    scope: "provider",
    category: "profile",
    labelRo: "SEO on-page",
    labelEn: "SEO optimization",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.profile.multi_locale",
    scope: "provider",
    category: "profile",
    labelRo: "Descrieri multi-limba",
    labelEn: "Multi-language descriptions",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.profile.verified_badge",
    scope: "provider",
    category: "profile",
    labelRo: "Badge Verified",
    labelEn: "Verified badge",
    type: "bool",
    status: "built",
    notes: "Conditional",
  },
  {
    key: "provider.profile.founding_badge",
    scope: "provider",
    category: "profile",
    labelRo: "Badge Medic Fondator",
    labelEn: "Founding Doctor badge",
    type: "bool",
    status: "built",
    notes: "Slot-based",
  },
  {
    key: "provider.schedule.recurring",
    scope: "provider",
    category: "schedule",
    labelRo: "Program recurent",
    labelEn: "Recurring schedule",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.schedule.exceptions_holidays",
    scope: "provider",
    category: "schedule",
    labelRo: "Exceptii si sarbatori",
    labelEn: "Exceptions and holidays",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.schedule.multi_location",
    scope: "provider",
    category: "schedule",
    labelRo: "Multi-location schedule",
    labelEn: "Multi-location schedule",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.schedule.vacation_planner",
    scope: "provider",
    category: "schedule",
    labelRo: "Planificator vacante",
    labelEn: "Vacation planner",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.schedule.daily_briefing",
    scope: "provider",
    category: "schedule",
    labelRo: "Briefing zilnic (ce urmeaza azi)",
    labelEn: "Daily briefing (today-preview)",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.bookings.per_month",
    scope: "provider",
    category: "booking",
    labelRo: "Programari/luna",
    labelEn: "Bookings per month",
    type: "quota",
    defaultLimit: 0,
    status: "built",
    notes: "With overage",
  },
  {
    key: "provider.bookings.online",
    scope: "provider",
    category: "booking",
    labelRo: "Online booking activat",
    labelEn: "Online booking enabled",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.bookings.buffer_time",
    scope: "provider",
    category: "booking",
    labelRo: "Travel buffer intre locatii",
    labelEn: "Travel buffer between locations",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.bookings.room_allocation",
    scope: "provider",
    category: "booking",
    labelRo: "Alocare room",
    labelEn: "Room allocation",
    type: "bool",
    status: "wip",
  },
  {
    key: "provider.booking.embed_widget",
    scope: "provider",
    category: "booking",
    labelRo: "Widget booking embeddabil pe site extern",
    labelEn: "Embeddable booking widget",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.booking.progressive_deposits",
    scope: "provider",
    category: "booking",
    labelRo: "Depozite progresive dupa no-shows",
    labelEn: "Progressive deposits after no-shows",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.facilities.max",
    scope: "provider",
    category: "booking",
    labelRo: "Locatii maxime",
    labelEn: "Max linked facilities",
    type: "quota",
    defaultLimit: 1,
    status: "built",
    notes: "Cap locatii per provider (lifetime)",
  },
  {
    key: "provider.service_areas.max",
    scope: "provider",
    category: "booking",
    labelRo: "Zone domiciliu maxime",
    labelEn: "Max home-visit zones",
    type: "quota",
    defaultLimit: 0,
    status: "built",
    notes: "Zone pentru home-visit",
  },
  {
    key: "provider.appointments.dashboard",
    scope: "provider",
    category: "appointments",
    labelRo: "Dashboard programari",
    labelEn: "Appointments dashboard",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.appointments.no_show_shield",
    scope: "provider",
    category: "appointments",
    labelRo: "No-Show Shield ML",
    labelEn: "No-Show Shield (ML risk)",
    type: "bool",
    status: "planned",
  },
  {
    key: "provider.appointments.no_show_cascade",
    scope: "provider",
    category: "appointments",
    labelRo: "Cascada no-show (push->Viber->SMS->email)",
    labelEn: "No-show cascade (push->Viber->SMS->email)",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.appointments.no_show_score_per_patient",
    scope: "provider",
    category: "appointments",
    labelRo: "Scor AI no-show per pacient",
    labelEn: "AI no-show risk score per patient",
    type: "bool",
    status: "planned",
  },
  {
    key: "provider.appointments.overbooking_ai",
    scope: "provider",
    category: "appointments",
    labelRo: "AI overbooking (predictie)",
    labelEn: "AI-driven overbooking prediction",
    type: "bool",
    status: "planned",
  },
  {
    key: "provider.patient.history",
    scope: "provider",
    category: "patient_care",
    labelRo: "Istoric pacient",
    labelEn: "Patient history",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.patient.reviews_reply",
    scope: "provider",
    category: "patient_care",
    labelRo: "Raspuns la recenzii",
    labelEn: "Reply to reviews",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.patient.messaging",
    scope: "provider",
    category: "patient_care",
    labelRo: "Mesagerie cu pacient E2E",
    labelEn: "E2E patient messaging",
    type: "bool",
    status: "planned",
  },
  {
    key: "provider.patient.symptom_router",
    scope: "provider",
    category: "patient_care",
    labelRo: "Router simptome AI (pacienti -> doctor)",
    labelEn: "AI symptom router (patient -> you)",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.clinical.notes_basic",
    scope: "provider",
    category: "clinical",
    labelRo: "Note consult basic",
    labelEn: "Basic consult notes",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.clinical.ai_soap_notes.per_month",
    scope: "provider",
    category: "clinical",
    labelRo: "AI SOAP notes/luna",
    labelEn: "AI SOAP notes per month",
    type: "quota",
    defaultLimit: 0,
    status: "wip",
    notes: "50 built/unlimited planned",
  },
  {
    key: "provider.clinical.diagnosis_suggestions",
    scope: "provider",
    category: "clinical",
    labelRo: "Sugestii diagnostic AI",
    labelEn: "AI diagnosis suggestions",
    type: "bool",
    status: "idea",
  },
  {
    key: "provider.clinical.prescriptions_digital",
    scope: "provider",
    category: "clinical",
    labelRo: "Retete digitale",
    labelEn: "Digital prescriptions",
    type: "bool",
    status: "planned",
  },
  {
    key: "provider.clinical.eprescription_sipe",
    scope: "provider",
    category: "clinical",
    labelRo: "ePrescription SIPE (RO)",
    labelEn: "ePrescription SIPE Romania",
    type: "bool",
    status: "planned",
  },
  {
    key: "provider.clinical.lab_results_request",
    scope: "provider",
    category: "clinical",
    labelRo: "Cerere analize integrate",
    labelEn: "Integrated lab results request",
    type: "bool",
    status: "idea",
  },
  {
    key: "provider.clinical.icd10_coding_ai",
    scope: "provider",
    category: "clinical",
    labelRo: "AI ICD-10 coding",
    labelEn: "AI ICD-10 coding",
    type: "bool",
    status: "idea",
  },
  {
    key: "provider.clinical.fhir_interop",
    scope: "provider",
    category: "clinical",
    labelRo: "FHIR interop",
    labelEn: "FHIR interoperability",
    type: "bool",
    status: "planned",
  },
  {
    key: "provider.video.consultations.per_month",
    scope: "provider",
    category: "video",
    labelRo: "Video consults/luna",
    labelEn: "Video consultations per month",
    type: "quota",
    defaultLimit: -1,
    status: "wip",
    notes: "Zoom/Meet/custom",
  },
  {
    key: "provider.video.consultations.online",
    scope: "provider",
    category: "video",
    labelRo: "Video booking activat",
    labelEn: "Video booking enabled",
    type: "bool",
    status: "built",
    notes: "Inclus si pe free",
  },
  {
    key: "provider.video.recording",
    scope: "provider",
    category: "video",
    labelRo: "Inregistrare consult (consent)",
    labelEn: "Session recording with consent",
    type: "bool",
    status: "idea",
  },
  {
    key: "provider.video.commission_pct",
    scope: "provider",
    category: "video",
    labelRo: "Comision video consultatii %",
    labelEn: "Video consultation commission %",
    type: "quota",
    defaultLimit: 10,
    status: "built",
    notes: "Free=10% Pro=7% Expert=5%",
  },
  {
    key: "provider.video.commission_cap_eur",
    scope: "provider",
    category: "video",
    labelRo: "Cap comision video EUR",
    labelEn: "Video commission cap EUR",
    type: "quota",
    defaultLimit: 0,
    status: "built",
  },
  {
    key: "provider.messaging.byop",
    scope: "provider",
    category: "messaging",
    labelRo: "Provider SMS propriu (BYOP)",
    labelEn: "Bring Your Own Provider",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.messaging.sms.per_month",
    scope: "provider",
    category: "messaging",
    labelRo: "SMS reminders",
    labelEn: "SMS reminders/month",
    type: "quota",
    defaultLimit: 0,
    status: "built",
    notes: "With overage",
  },
  {
    key: "provider.messaging.viber.per_month",
    scope: "provider",
    category: "messaging",
    labelRo: "Viber messages",
    labelEn: "Viber messages/month",
    type: "quota",
    defaultLimit: 0,
    status: "built",
  },
  {
    key: "provider.messaging.whatsapp.per_month",
    scope: "provider",
    category: "messaging",
    labelRo: "WhatsApp messages",
    labelEn: "WhatsApp messages/month",
    type: "quota",
    defaultLimit: 0,
    status: "built",
  },
  {
    key: "provider.messaging.push.per_month",
    scope: "provider",
    category: "messaging",
    labelRo: "Push notifications",
    labelEn: "Push notifications/month",
    type: "quota",
    defaultLimit: -1,
    status: "built",
    notes: "-1=unlimited",
  },
  {
    key: "provider.transaction_fee_pct",
    scope: "provider",
    category: "financial",
    labelRo: "Comision tranzactii %",
    labelEn: "Transaction fee percent",
    type: "quota",
    defaultLimit: 10,
    status: "built",
    // Copy only: the money code charges `pricing_plans.transaction_fee_pct`.
    // scripts/plan-commission-set.ts writes both, with provider.video.commission_pct.
    notes: "Free=10% Pro=7% Premium=5%",
  },
  {
    key: "provider.transaction_fee_cap_eur",
    scope: "provider",
    category: "financial",
    labelRo: "Cap comision EUR",
    labelEn: "Transaction fee cap EUR",
    type: "quota",
    defaultLimit: 0,
    status: "built",
  },
  {
    key: "provider.revenue_dashboard",
    scope: "provider",
    category: "financial",
    labelRo: "Dashboard venituri",
    labelEn: "Revenue dashboard",
    type: "bool",
    status: "planned",
  },
  {
    key: "provider.invoice_generation",
    scope: "provider",
    category: "financial",
    labelRo: "Facturare automata",
    labelEn: "Automated invoicing",
    type: "bool",
    status: "planned",
  },
  {
    key: "provider.payments.stripe_express_iban",
    scope: "provider",
    category: "financial",
    labelRo: "Plati directe IBAN (Stripe Express)",
    labelEn: "Direct IBAN payouts (Stripe Express)",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.payments.payout_instant",
    scope: "provider",
    category: "financial",
    labelRo: "Payout instant +1% sau gratis 3-7 zile",
    labelEn: "Instant payout +1% or free 3-7 days",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.wallet.wise_cashout",
    scope: "provider",
    category: "financial",
    labelRo: "Wallet + cash-out Wise (min EUR50)",
    labelEn: "Wallet with Wise cash-out (min EUR50)",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.analytics.basic",
    scope: "provider",
    category: "analytics",
    labelRo: "Analytics programari",
    labelEn: "Basic appointments analytics",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.analytics.benchmark",
    scope: "provider",
    category: "analytics",
    labelRo: "Benchmark vs similar",
    labelEn: "Benchmark dashboard",
    type: "bool",
    status: "planned",
  },
  {
    key: "provider.analytics.conversion_funnel",
    scope: "provider",
    category: "analytics",
    labelRo: "Funnel view->book",
    labelEn: "View to book conversion funnel",
    type: "bool",
    status: "idea",
  },
  {
    key: "provider.referral.network",
    scope: "provider",
    category: "growth",
    labelRo: "Retea referral",
    labelEn: "Referral network",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.referral.program_3y",
    scope: "provider",
    category: "growth",
    labelRo: "Program referral 3 ani (20%/10%/5%)",
    labelEn: "3-year referral program (20%/10%/5% commissions)",
    type: "bool",
    status: "built",
  },
  {
    // D8 (2026-09-19): doctor-to-doctor medical referrals are NOT built — the
    // `Referral` model has zero readers/writers — so we stop selling them.
    // Downgraded from "wip" to "planned" and removed from every plan below, so
    // the key resolves to the `hidden` default until the feature ships.
    // (`status` is a dev-status: "built" | "wip" | "planned" | "idea"; "soon" is
    // an *access* level, not a status — hence "planned" here + no plan entry.)
    key: "provider.referral.outbound_specialist",
    scope: "provider",
    category: "growth",
    labelRo: "Trimite pacient la coleg",
    labelEn: "Outbound specialist referral",
    type: "bool",
    status: "planned",
  },
  {
    key: "provider.challenges",
    scope: "provider",
    category: "growth",
    labelRo: "Challenges + badges",
    labelEn: "Challenges and badges",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.medical_journal",
    scope: "provider",
    category: "growth",
    labelRo: "Medical journal AI-curated",
    labelEn: "AI-curated medical journal",
    type: "bool",
    status: "planned",
  },
  {
    key: "provider.api_access",
    scope: "provider",
    category: "premium",
    labelRo: "API personal",
    labelEn: "Personal API access",
    type: "bool",
    status: "planned",
  },
  {
    key: "provider.cross_border",
    scope: "provider",
    category: "premium",
    labelRo: "Pacienti cross-country",
    labelEn: "Cross-country patients",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.white_label_booking_widget",
    scope: "provider",
    category: "premium",
    labelRo: "Widget embed site propriu",
    labelEn: "Embeddable booking widget",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.lifetime_founding",
    scope: "provider",
    category: "premium",
    labelRo: "Plan gratuit pe viata (fondator)",
    labelEn: "Lifetime free plan (founder)",
    type: "bool",
    status: "built",
    notes: "Slot-based",
  },
  {
    key: "provider.team.staff_invites",
    scope: "provider",
    category: "premium",
    labelRo: "Echipa staff (4 roluri: office mgr/assistant/recep/accountant)",
    labelEn: "Team staff (4 roles: office mgr/assistant/recep/accountant)",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.branding.advanced",
    scope: "provider",
    category: "premium",
    labelRo: "Branding avansat (logo/culori/bio extins)",
    labelEn: "Advanced branding (logo/colors/extended bio)",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.multi_location_dashboard",
    scope: "provider",
    category: "premium",
    labelRo: "Dashboard multi-locatie (pt doctor individual)",
    labelEn: "Multi-location dashboard (for individual doctor)",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.api_access.calls_per_month",
    scope: "provider",
    category: "premium",
    labelRo: "API REST public",
    labelEn: "Public REST API calls per month",
    type: "quota",
    defaultLimit: 0,
    status: "built",
  },
  {
    key: "provider.calendar.api_audit",
    scope: "provider",
    category: "premium",
    labelRo: "Calendar unificat API + audit log",
    labelEn: "Unified calendar API + audit log",
    type: "bool",
    status: "built",
  },
  {
    key: "provider.security.enforced_2fa",
    scope: "provider",
    category: "security",
    labelRo: "2FA TOTP obligatoriu",
    labelEn: "Enforced 2FA TOTP",
    type: "bool",
    status: "built",
    notes: "Per CLAUDE.md mandatory pentru toti doctorii",
  },
  {
    key: "provider.security.audit_log",
    scope: "provider",
    category: "security",
    labelRo: "Audit log actiuni cont doctor",
    labelEn: "Doctor account audit log",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.sub_locations.max",
    scope: "facility",
    category: "capacity",
    labelRo: "Sub-locatii",
    labelEn: "Sub-locations",
    type: "quota",
    defaultLimit: 2,
    status: "built",
  },
  {
    key: "facility.staff_users.max",
    scope: "facility",
    category: "capacity",
    labelRo: "Useri staff",
    labelEn: "Staff users",
    type: "quota",
    defaultLimit: 3,
    status: "built",
  },
  {
    key: "facility.doctors_included",
    scope: "facility",
    category: "capacity",
    labelRo: "Doctori inclusi (seats bundle)",
    labelEn: "Doctors included (seats bundle)",
    type: "quota",
    defaultLimit: 0,
    status: "built",
  },
  {
    key: "facility.profile.public_page",
    scope: "facility",
    category: "identity",
    labelRo: "Pagina publica clinica",
    labelEn: "Public clinic page",
    type: "bool",
    status: "built",
  },
  {
    key: "facility.profile.completeness_score",
    scope: "facility",
    category: "identity",
    labelRo: "Completeness score 11-puncte",
    labelEn: "11-point completeness score",
    type: "bool",
    status: "built",
  },
  {
    key: "facility.profile.claim_verify",
    scope: "facility",
    category: "identity",
    labelRo: "Claim + Verified badge",
    labelEn: "Claim and verification",
    type: "bool",
    status: "wip",
  },
  {
    key: "facility.profile.multi_locale",
    scope: "facility",
    category: "identity",
    labelRo: "Descrieri multi-limba",
    labelEn: "Multi-language descriptions",
    type: "bool",
    status: "built",
  },
  {
    key: "facility.profile.gallery.photos_max",
    scope: "facility",
    category: "identity",
    labelRo: "Fotografii clinica",
    labelEn: "Clinic gallery photos",
    type: "quota",
    defaultLimit: 2,
    status: "built",
  },
  {
    key: "facility.profile.seo",
    scope: "facility",
    category: "identity",
    labelRo: "SEO optimizat",
    labelEn: "SEO optimization",
    type: "bool",
    status: "built",
  },
  {
    key: "facility.staff.roles_6",
    scope: "facility",
    category: "staff",
    labelRo: "6 roluri + 25 permisiuni",
    labelEn: "6 roles and 25 permissions",
    type: "bool",
    status: "wip",
  },
  {
    key: "facility.staff.audit_log",
    scope: "facility",
    category: "staff",
    labelRo: "Audit log actiuni",
    labelEn: "Actions audit log",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.staff.sso",
    scope: "facility",
    category: "staff",
    labelRo: "SSO enterprise",
    labelEn: "Enterprise SSO",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.staff.enforced_2fa",
    scope: "facility",
    category: "staff",
    labelRo: "2FA obligatoriu",
    labelEn: "Enforced 2FA",
    type: "bool",
    status: "built",
  },
  {
    key: "facility.invitation_flows",
    scope: "facility",
    category: "staff",
    labelRo: "Invitation flows universale (accept/decline)",
    labelEn: "Universal invitation flows (accept/decline)",
    type: "bool",
    status: "built",
  },
  {
    key: "facility.doctors.affiliation_roles_4",
    scope: "facility",
    category: "doctor_affiliation",
    labelRo: "4 roluri afiliere doctor",
    labelEn: "4 affiliation roles (owner/emp/collab/resident)",
    type: "bool",
    status: "built",
  },
  {
    key: "facility.doctors.seat_allocation",
    scope: "facility",
    category: "doctor_affiliation",
    labelRo: "Alocare seats pe doctor",
    labelEn: "Seat allocation per doctor",
    type: "bool",
    status: "built",
  },
  {
    key: "facility.calendar.multi_doctor_view",
    scope: "facility",
    category: "operations",
    labelRo: "View agregat multi-doctor",
    labelEn: "Aggregate multi-doctor calendar view",
    type: "bool",
    status: "built",
  },
  {
    key: "facility.calendar.color_coding",
    scope: "facility",
    category: "operations",
    labelRo: "Color coding 8 culori",
    labelEn: "Color coding 8 colors",
    type: "bool",
    status: "built",
  },
  {
    key: "facility.rooms.management",
    scope: "facility",
    category: "operations",
    labelRo: "Rooms management CRUD",
    labelEn: "Rooms management CRUD",
    type: "bool",
    status: "wip",
  },
  {
    key: "facility.checkin.kiosk_qr",
    scope: "facility",
    category: "operations",
    labelRo: "Check-in kiosk QR",
    labelEn: "Check-in kiosk QR",
    type: "bool",
    status: "built",
    notes: "Diferentiator",
  },
  {
    key: "facility.checkin.tv_waiting_room",
    scope: "facility",
    category: "operations",
    labelRo: "TV waiting room display",
    labelEn: "TV waiting room display",
    type: "bool",
    status: "built",
    notes: "Diferentiator",
  },
  {
    key: "facility.queue.live_board",
    scope: "facility",
    category: "operations",
    labelRo: "Queue live + next-patient",
    labelEn: "Queue live and next-patient",
    type: "bool",
    status: "built",
  },
  {
    key: "facility.walkin_tracking",
    scope: "facility",
    category: "operations",
    labelRo: "Walk-in vs appointment",
    labelEn: "Walk-in vs appointment tracking",
    type: "bool",
    status: "built",
  },
  {
    key: "facility.branding.custom_kiosk_tv",
    scope: "facility",
    category: "operations",
    labelRo: "Custom branding kiosk + TV (logo/culori)",
    labelEn: "Custom branding kiosk + TV (logo/colors)",
    type: "bool",
    status: "built",
  },
  {
    key: "facility.finance.daily_close",
    scope: "facility",
    category: "financial",
    labelRo: "Daily close reports",
    labelEn: "Daily close reports",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.finance.revenue_per_doctor",
    scope: "facility",
    category: "financial",
    labelRo: "Revenue/doctor si serviciu",
    labelEn: "Revenue per doctor and service",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.finance.outstanding_balances",
    scope: "facility",
    category: "financial",
    labelRo: "Solduri pacienti",
    labelEn: "Patient outstanding balances",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.finance.pos_lite",
    scope: "facility",
    category: "financial",
    labelRo: "POS lite in-clinic",
    labelEn: "POS lite in-clinic",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.finance.insurance_claims_private",
    scope: "facility",
    category: "financial",
    labelRo: "Claims asiguratori privati",
    labelEn: "Private insurance claims",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.finance.insurance_claims_cnas",
    scope: "facility",
    category: "financial",
    labelRo: "CNAS claims (RO)",
    labelEn: "CNAS claims (RO)",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.payments.stripe_express_iban",
    scope: "facility",
    category: "financial",
    labelRo: "Plati IBAN clinica (Stripe Express)",
    labelEn: "Direct IBAN clinic payouts (Stripe Express)",
    type: "bool",
    status: "built",
  },
  {
    key: "facility.finance.reports_bundled",
    scope: "facility",
    category: "financial",
    labelRo: "Financial reports bundle (revenue+daily close+outstanding+POS)",
    labelEn: "Bundled financial reports (revenue+daily close+outstanding+POS)",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.crm.patient_db_wide",
    scope: "facility",
    category: "crm",
    labelRo: "DB pacienti clinic-wide",
    labelEn: "Clinic-wide patient DB",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.crm.patient_timeline",
    scope: "facility",
    category: "crm",
    labelRo: "Patient timeline (vizite + docs + comunicari)",
    labelEn: "Patient timeline (visits + docs + comms)",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.crm.follow_up_reminders",
    scope: "facility",
    category: "crm",
    labelRo: "Follow-up reminders post-consult",
    labelEn: "Post-consult follow-up reminders",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.crm.tags_segments",
    scope: "facility",
    category: "crm",
    labelRo: "Tag-uri si segmente",
    labelEn: "Tags and segments",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.crm.campaigns.per_month",
    scope: "facility",
    category: "crm",
    labelRo: "Campanii SMS/email",
    labelEn: "SMS/email campaigns per month",
    type: "quota",
    defaultLimit: 0,
    status: "planned",
  },
  {
    key: "facility.crm.satisfaction_surveys",
    scope: "facility",
    category: "crm",
    labelRo: "Surveys post-consult",
    labelEn: "Post-consult satisfaction surveys",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.crm.lead_capture_forms",
    scope: "facility",
    category: "crm",
    labelRo: "Formulare pe site clinica",
    labelEn: "Lead capture forms",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.crm.review_management",
    scope: "facility",
    category: "crm",
    labelRo: "Review management agregat",
    labelEn: "Aggregate review management",
    type: "bool",
    status: "wip",
  },
  {
    key: "facility.docs.vault_storage_gb",
    scope: "facility",
    category: "documents",
    labelRo: "Vault documente GB",
    labelEn: "Documents vault GB",
    type: "quota",
    defaultLimit: 1,
    status: "built",
  },
  {
    key: "facility.docs.templates",
    scope: "facility",
    category: "documents",
    labelRo: "Template-uri contracte/consents",
    labelEn: "Contracts/consents templates",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.docs.ai_extraction",
    scope: "facility",
    category: "documents",
    labelRo: "AI extract din PDF/imagine",
    labelEn: "AI extraction from PDF/image",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.docs.esignature_eidas",
    scope: "facility",
    category: "documents",
    labelRo: "E-signatures eIDAS",
    labelEn: "E-signatures eIDAS",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.docs.gdpr_consents",
    scope: "facility",
    category: "documents",
    labelRo: "Consents GDPR auto-track",
    labelEn: "Auto-tracked GDPR consents",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.chain.dashboard_kpi",
    scope: "facility",
    category: "chain",
    labelRo: "Multi-location dashboard KPI",
    labelEn: "Multi-location KPI dashboard",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.chain.brand_enforcement",
    scope: "facility",
    category: "chain",
    labelRo: "Brand consistency branches",
    labelEn: "Brand consistency across branches",
    type: "bool",
    status: "idea",
  },
  {
    key: "facility.chain.centralized_billing",
    scope: "facility",
    category: "chain",
    labelRo: "Billing consolidat",
    labelEn: "Consolidated billing",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.referral.cross_clinic",
    scope: "facility",
    category: "chain",
    labelRo: "Retea referral intre clinici (cross-clinic patient)",
    labelEn: "Cross-clinic patient referral network",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.support.priority_4h",
    scope: "facility",
    category: "support",
    labelRo: "Suport prioritar (<4h raspuns)",
    labelEn: "Priority support (<4h response)",
    type: "bool",
    status: "built",
    notes: "Enterprise only",
  },
  {
    key: "facility.support.account_manager",
    scope: "facility",
    category: "support",
    labelRo: "Account manager dedicat",
    labelEn: "Dedicated account manager",
    type: "bool",
    status: "built",
    notes: "Enterprise only",
  },
  {
    key: "facility.hr.shift_scheduling",
    scope: "facility",
    category: "workforce",
    labelRo: "Shift scheduling",
    labelEn: "Shift scheduling",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.hr.attendance_tracking",
    scope: "facility",
    category: "workforce",
    labelRo: "Pontaj prezenta",
    labelEn: "Attendance tracking",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.hr.leave_management",
    scope: "facility",
    category: "workforce",
    labelRo: "Concedii",
    labelEn: "Leave management",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.hr.payroll_prep",
    scope: "facility",
    category: "workforce",
    labelRo: "Export salarii",
    labelEn: "Payroll export",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.inventory.stock",
    scope: "facility",
    category: "inventory",
    labelRo: "Stoc + SKU",
    labelEn: "Stock and SKU",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.inventory.low_stock_alerts",
    scope: "facility",
    category: "inventory",
    labelRo: "Alerte low-stock",
    labelEn: "Low-stock alerts",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.inventory.usage_per_procedure",
    scope: "facility",
    category: "inventory",
    labelRo: "Consum/procedura",
    labelEn: "Usage per procedure",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.analytics.dashboard",
    scope: "facility",
    category: "analytics",
    labelRo: "Dashboard clinica",
    labelEn: "Clinic dashboard",
    type: "bool",
    status: "built",
    notes: "Basic",
  },
  {
    key: "facility.analytics.benchmark_anon",
    scope: "facility",
    category: "analytics",
    labelRo: "Benchmark anonimizat",
    labelEn: "Anonymized benchmark",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.analytics.custom_reports",
    scope: "facility",
    category: "analytics",
    labelRo: "Custom report builder",
    labelEn: "Custom report builder",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.analytics.export.per_month",
    scope: "facility",
    category: "analytics",
    labelRo: "Export-uri CSV/PDF",
    labelEn: "CSV/PDF exports per month",
    type: "quota",
    defaultLimit: 5,
    status: "built",
  },
  {
    key: "facility.analytics.advanced",
    scope: "facility",
    category: "analytics",
    labelRo: "Analytics avansat (trends/specialitati/ore/surse pacienti)",
    labelEn: "Advanced analytics (trends/specialties/hours/patient sources)",
    type: "bool",
    status: "built",
  },
  {
    key: "facility.analytics.forecasting",
    scope: "facility",
    category: "analytics",
    labelRo: "Forecasting + trend projection",
    labelEn: "Forecasting and trend projection",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.api.access",
    scope: "facility",
    category: "api",
    labelRo: "API + webhooks",
    labelEn: "API and webhooks",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.api.calls_per_month",
    scope: "facility",
    category: "api",
    labelRo: "Quota API calls",
    labelEn: "API calls per month",
    type: "quota",
    defaultLimit: 0,
    status: "planned",
  },
  {
    key: "facility.integrations.pms_import",
    scope: "facility",
    category: "api",
    labelRo: "Import din PMS extern",
    labelEn: "External PMS import",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.integrations.fhir",
    scope: "facility",
    category: "api",
    labelRo: "FHIR interop",
    labelEn: "FHIR interoperability",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.white_label_portal",
    scope: "facility",
    category: "api",
    labelRo: "Portal pacienti branded",
    labelEn: "White-label patient portal",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.video.webrtc",
    scope: "facility",
    category: "automation",
    labelRo: "Video platform WebRTC",
    labelEn: "Video platform WebRTC",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.ai.phone_assistant",
    scope: "facility",
    category: "automation",
    labelRo: "AI receptionist telefonic",
    labelEn: "AI phone receptionist",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.ai.no_show_shield",
    scope: "facility",
    category: "automation",
    labelRo: "No-Show Shield clinic-level",
    labelEn: "Clinic-level No-Show Shield",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.automation.marketing_journeys",
    scope: "facility",
    category: "automation",
    labelRo: "Nurture journeys marketing",
    labelEn: "Marketing nurture journeys",
    type: "bool",
    status: "planned",
  },
  {
    key: "facility.reminders.sms.per_month",
    scope: "facility",
    category: "reminders",
    labelRo: "SMS reminders clinica",
    labelEn: "Clinic SMS reminders",
    type: "quota",
    defaultLimit: 0,
    status: "built",
    notes: "With overage",
  },
  {
    key: "facility.reminders.viber.per_month",
    scope: "facility",
    category: "reminders",
    labelRo: "Viber reminders clinica",
    labelEn: "Clinic Viber reminders",
    type: "quota",
    defaultLimit: 0,
    status: "built",
  },
  {
    key: "facility.reminders.whatsapp.per_month",
    scope: "facility",
    category: "reminders",
    labelRo: "WhatsApp reminders clinica",
    labelEn: "Clinic WhatsApp reminders",
    type: "quota",
    defaultLimit: 0,
    status: "built",
  },
  {
    key: "facility.reminders.byop",
    scope: "facility",
    category: "reminders",
    labelRo: "Provider mesagerie propriu",
    labelEn: "Own messaging provider",
    type: "bool",
    status: "built",
  },
  {
    key: "business.profile.listing_public_data",
    scope: "business",
    category: "profile",
    labelRo: "Listare din date publice (nume+adresa)",
    labelEn: "Listing from public data (name+address only)",
    type: "bool",
    status: "built",
    notes: "Site: business_free = 2 features only",
  },
  {
    key: "business.profile.full_editable",
    scope: "business",
    category: "profile",
    labelRo: "Profil complet editabil (nume/adresa/descriere multi-limba)",
    labelEn: "Full editable profile (name/address/multi-lang description)",
    type: "bool",
    status: "built",
  },
  {
    key: "business.profile.contact_multi",
    scope: "business",
    category: "profile",
    labelRo: "Contact multi-numar + multi-email",
    labelEn: "Multi-phone + multi-email contact",
    type: "bool",
    status: "built",
  },
  {
    key: "business.profile.opening_hours",
    scope: "business",
    category: "profile",
    labelRo: "Opening hours per-zi + sarbatori legale",
    labelEn: "Opening hours + legal holidays",
    type: "bool",
    status: "built",
  },
  {
    key: "business.profile.accessibility",
    scope: "business",
    category: "profile",
    labelRo: "Accesibilitate (wheelchair/parking/copii/transport)",
    labelEn: "Accessibility (wheelchair/parking/kids/transport)",
    type: "bool",
    status: "built",
  },
  {
    key: "business.profile.languages_support",
    scope: "business",
    category: "profile",
    labelRo: "Languages support (turisti/expats)",
    labelEn: "Language support (tourists/expats)",
    type: "bool",
    status: "built",
  },
  {
    key: "business.profile.reviews_reply",
    scope: "business",
    category: "profile",
    labelRo: "Raspuns la recenzii",
    labelEn: "Reply to reviews",
    type: "bool",
    status: "built",
  },
  {
    key: "business.profile.branded_page",
    scope: "business",
    category: "profile",
    labelRo: "Pagina branded custom",
    labelEn: "Branded custom page",
    type: "bool",
    status: "built",
  },
  {
    key: "business.profile.services_catalog",
    scope: "business",
    category: "profile",
    labelRo: "Catalog servicii",
    labelEn: "Services catalog",
    type: "bool",
    status: "built",
  },
  {
    key: "business.profile.gallery.photos_max",
    scope: "business",
    category: "profile",
    labelRo: "Fotografii galerie",
    labelEn: "Gallery photos",
    type: "quota",
    defaultLimit: 5,
    status: "built",
  },
  {
    key: "business.profile.seo",
    scope: "business",
    category: "profile",
    labelRo: "SEO optimizat (nameAscii/meta/Google Place ID)",
    labelEn: "SEO optimized (nameAscii/meta/Google Place ID)",
    type: "bool",
    status: "built",
  },
  {
    key: "business.multi_specialty",
    scope: "business",
    category: "profile",
    labelRo: "Listare multi-specialitate",
    labelEn: "Multi-specialty listing",
    type: "bool",
    status: "built",
  },
  {
    key: "business.cross_border_services",
    scope: "business",
    category: "profile",
    labelRo: "Servicii cross-country",
    labelEn: "Cross-country services",
    type: "bool",
    status: "built",
  },
  {
    key: "business.staff_doctors",
    scope: "business",
    category: "profile",
    labelRo: "Afisare medici angajati",
    labelEn: "Employed doctors display",
    type: "bool",
    status: "built",
  },
  {
    key: "business.landing_pages.max",
    scope: "business",
    category: "growth",
    labelRo: "Landing pages SEO",
    labelEn: "SEO landing pages",
    type: "quota",
    defaultLimit: 0,
    status: "planned",
  },
  {
    key: "business.search.priority",
    scope: "business",
    category: "growth",
    labelRo: "Priority in search results",
    labelEn: "Priority in search results",
    type: "bool",
    status: "built",
  },
  {
    key: "business.search.claim_verify",
    scope: "business",
    category: "growth",
    labelRo: "Claim + verification flow (Verified badge)",
    labelEn: "Claim + verification (Verified badge)",
    type: "bool",
    status: "built",
  },
  {
    key: "business.reminders.automated",
    scope: "business",
    category: "growth",
    labelRo: "Remindere automate (email/push/SMS optional)",
    labelEn: "Automated reminders (email/push/SMS optional)",
    type: "bool",
    status: "built",
  },
  {
    key: "business.insurance_display",
    scope: "business",
    category: "growth",
    labelRo: "Insurance display (CNAS + asiguratori privati)",
    labelEn: "Insurance display (CNAS + private insurers)",
    type: "bool",
    status: "built",
  },
  {
    key: "business.multi_location",
    scope: "business",
    category: "growth",
    labelRo: "Multi-location (chain: HQ + branches)",
    labelEn: "Multi-location (chain: HQ + branches)",
    type: "bool",
    status: "built",
  },
  {
    key: "business.hours.custom_holidays",
    scope: "business",
    category: "growth",
    labelRo: "Custom hours + holiday overrides",
    labelEn: "Custom hours + holiday overrides",
    type: "bool",
    status: "built",
  },
  {
    key: "business.leads.dashboard",
    scope: "business",
    category: "growth",
    labelRo: "Leads dashboard",
    labelEn: "Leads dashboard",
    type: "bool",
    status: "planned",
  },
  {
    key: "business.leads.crm_pipeline",
    scope: "business",
    category: "growth",
    labelRo: "CRM pipeline leads",
    labelEn: "Leads CRM pipeline",
    type: "bool",
    status: "planned",
  },
  {
    key: "business.analytics.views_conversions",
    scope: "business",
    category: "growth",
    labelRo: "Views si conversions",
    labelEn: "Views and conversions analytics",
    type: "bool",
    status: "wip",
  },
  {
    key: "business.referral_partnership",
    scope: "business",
    category: "growth",
    labelRo: "Program parteneriat",
    labelEn: "Partnership program",
    type: "bool",
    status: "built",
  },
  {
    key: "business.api_access",
    scope: "business",
    category: "premium",
    labelRo: "API access",
    labelEn: "API access",
    type: "bool",
    status: "planned",
  },
  {
    key: "business.white_label",
    scope: "business",
    category: "premium",
    labelRo: "White-label microsite",
    labelEn: "White-label microsite",
    type: "bool",
    status: "idea",
  },
  {
    key: "business.messaging.sms.per_month",
    scope: "business",
    category: "messaging",
    labelRo: "SMS outreach",
    labelEn: "SMS outreach per month",
    type: "quota",
    defaultLimit: 0,
    status: "planned",
  },
  {
    key: "business.pharmacy.online_orders",
    scope: "business",
    category: "pharmacy",
    labelRo: "Comenzi online farmacie (prescriptii + OTC)",
    labelEn: "Online pharmacy orders (prescriptions + OTC)",
    type: "bool",
    status: "planned",
    notes: "Vertical: farmacii",
  },
  {
    key: "business.lab.slot_booking",
    scope: "business",
    category: "lab",
    labelRo: "Rezervari sloturi laborator (recoltari + imagistica)",
    labelEn: "Lab slot booking (sampling + imaging)",
    type: "bool",
    status: "planned",
    notes: "Vertical: laboratoare",
  },
];

export const FEATURE_BY_KEY: Record<string, FeatureDefinition> = Object.fromEntries(
  FEATURES.map((f) => [f.key, f]),
);

export const PLAN_FEATURE_DEFAULTS: Record<string, Record<string, PlanFeatureAccess>> = {
  user_free: {
    "user.profile": { access: "included" },
    "user.family_members.max": { access: "limited", limit: 2 },
    "user.proxy_booking": { access: "included" },
    "user.history.retention_months": { access: "limited", limit: 24 },
    "user.favorites.max": { access: "limited", limit: 3 },
    "user.saved_searches.max": { access: "limited", limit: 5 },
    "user.collections.max": { access: "limited", limit: 10 },
    "user.collections.items_per_collection.max": { access: "limited", limit: 5 },
    "user.compare.results_max": { access: "limited", limit: 2 },
    "user.search.basic": { access: "included" },
    "user.search.filters_advanced": { access: "included" },
    "user.search.cross_border": { access: "included" },
    "user.search.ai_semantic": { access: "soon" },
    "user.search.symptom_checker.per_month": { access: "soon" },
    "user.search.voice": { access: "included" },
    "user.book.standard": { access: "included" },
    "user.book.active_concurrent.max": { access: "limited", limit: 3 },
    "user.book.waitlist": { access: "included" },
    "user.book.reschedule_free.per_booking": { access: "limited", limit: 0 },
    "user.book.recurring": { access: "soon" },
    "user.book.family_scheduling": { access: "soon" },
    "user.vault.storage_mb": { access: "limited", limit: 100 },
    "user.vault.biometric_unlock": { access: "included" },
    "user.vault.ai_extraction.per_month": { access: "soon" },
    "user.vault.share_with_doctor": { access: "included" },
    "user.journal.notes.per_month": { access: "limited", limit: 10 },
    "user.messaging_doctor": { access: "soon" },
    "user.video_consult": { access: "included" },
    "user.reminders_push": { access: "included" },
    "user.referral_wallet": { access: "included" },
    "user.challenges": { access: "included" },
    "user.post_reviews": { access: "included" },
  },
  user_plus: {
    "user.profile": { access: "included" },
    "user.family_members.max": { access: "limited", limit: -1 },
    "user.proxy_booking": { access: "included" },
    "user.history.retention_months": { access: "limited", limit: -1 },
    "user.favorites.max": { access: "limited", limit: -1 },
    "user.saved_searches.max": { access: "limited", limit: -1 },
    "user.saved_searches.alerts": { access: "included" },
    "user.collections.max": { access: "limited", limit: -1 },
    "user.collections.items_per_collection.max": { access: "limited", limit: -1 },
    "user.collections.annotations": { access: "included" },
    "user.collections.sharing": { access: "included" },
    "user.compare.results_max": { access: "limited", limit: 5 },
    "user.ads_free": { access: "included" },
    "user.punctuality_rewards": { access: "soon" },
    "user.search.basic": { access: "included" },
    "user.search.filters_advanced": { access: "included" },
    "user.search.cross_border": { access: "included" },
    "user.search.ai_semantic": { access: "included" },
    "user.search.symptom_checker.per_month": { access: "limited", limit: 20 },
    "user.search.ai_medic_match": { access: "included" },
    "user.search.voice": { access: "included" },
    "user.book.standard": { access: "included" },
    "user.book.active_concurrent.max": { access: "limited", limit: 10 },
    "user.book.waitlist": { access: "included" },
    "user.book.waitlist_autofill": { access: "included" },
    "user.book.reschedule_free.per_booking": { access: "limited", limit: 2 },
    "user.book.recurring": { access: "soon" },
    "user.book.family_scheduling": { access: "soon" },
    "user.book.priority_slots": { access: "soon" },
    "user.vault.storage_mb": { access: "limited", limit: 2048 },
    "user.vault.biometric_unlock": { access: "included" },
    "user.vault.ai_extraction.per_month": { access: "limited", limit: 50 },
    "user.vault.ai_summary.per_month": { access: "soon" },
    "user.vault.share_with_doctor": { access: "included" },
    "user.vault.fhir_export": { access: "included" },
    "user.medical_journal": { access: "included" },
    "user.journal.notes.per_month": { access: "limited", limit: -1 },
    "user.journal.documents": { access: "included" },
    "user.journal.metrics": { access: "included" },
    "user.journal.pin": { access: "included" },
    "user.messaging_doctor": { access: "included" },
    "user.video_consult": { access: "included" },
    "user.calendar_sync": { access: "included" },
    "user.health_calendar": { access: "included" },
    "user.reminders_push": { access: "included" },
    "user.reminders_multichannel": { access: "included" },
    "user.referral_wallet": { access: "included" },
    "user.challenges": { access: "included" },
    "user.post_reviews": { access: "included" },
    "user.ai_assistant_personal.per_month": { access: "soon" },
    "user.priority_support": { access: "soon" },
    "user.early_access": { access: "soon" },
  },
  provider_free: {
    "provider.profile.basic": { access: "included" },
    "provider.profile.gallery.photos_max": { access: "limited", limit: 1 },
    "provider.profile.seo_optimization": { access: "included" },
    "provider.profile.multi_locale": { access: "included" },
    "provider.profile.verified_badge": { access: "included" },
    "provider.schedule.recurring": { access: "included" },
    "provider.schedule.exceptions_holidays": { access: "included" },
    "provider.schedule.multi_location": { access: "included" },
    // D3 (2026-09-19): the free doctor plan gets 10 in-office/online bookings
    // per month. Before this, `per_month` was 0 and `bookings.online` was absent
    // (= hidden), which made every unpaid claimed doctor unbookable.
    "provider.bookings.per_month": { access: "limited", limit: 10, upgradeTo: "provider_pro" },
    "provider.bookings.online": { access: "included" },
    "provider.booking.embed_widget": { access: "included" },
    "provider.facilities.max": { access: "limited", limit: 1 },
    "provider.service_areas.max": { access: "limited", limit: 0 },
    "provider.appointments.dashboard": { access: "included" },
    "provider.patient.history": { access: "included" },
    "provider.patient.reviews_reply": { access: "included" },
    "provider.patient.symptom_router": { access: "included" },
    "provider.clinical.notes_basic": { access: "included" },
    "provider.clinical.ai_soap_notes.per_month": { access: "limited", limit: 0 },
    "provider.video.consultations.per_month": { access: "limited", limit: -1 },
    "provider.video.consultations.online": { access: "included" },
    "provider.video.commission_pct": { access: "limited", limit: 10 },
    "provider.video.commission_cap_eur": { access: "limited", limit: 0 },
    "provider.messaging.sms.per_month": { access: "limited", limit: 0 },
    "provider.messaging.viber.per_month": { access: "limited", limit: 0 },
    "provider.messaging.whatsapp.per_month": { access: "limited", limit: 0 },
    "provider.messaging.push.per_month": { access: "limited", limit: -1 },
    "provider.transaction_fee_pct": { access: "limited", limit: 10 },
    "provider.transaction_fee_cap_eur": { access: "limited", limit: 0 },
    "provider.payments.stripe_express_iban": { access: "included" },
    "provider.payments.payout_instant": { access: "included" },
    "provider.wallet.wise_cashout": { access: "included" },
    "provider.referral.network": { access: "included" },
    "provider.referral.program_3y": { access: "included" },
    "provider.challenges": { access: "included" },
    "provider.api_access.calls_per_month": { access: "limited", limit: 0 },
    "provider.security.enforced_2fa": { access: "included" },
  },
  provider_pro: {
    "provider.profile.basic": { access: "included" },
    "provider.profile.branded_page": { access: "included" },
    "provider.profile.gallery.photos_max": { access: "limited", limit: 20 },
    "provider.profile.seo_optimization": { access: "included" },
    "provider.profile.multi_locale": { access: "included" },
    "provider.profile.verified_badge": { access: "included" },
    "provider.profile.founding_badge": { access: "included" },
    "provider.schedule.recurring": { access: "included" },
    "provider.schedule.exceptions_holidays": { access: "included" },
    "provider.schedule.multi_location": { access: "included" },
    "provider.schedule.vacation_planner": { access: "included" },
    "provider.schedule.daily_briefing": { access: "included" },
    // D2 (2026-09-19): Pro is €29 with 50 bookings/month (was €49 / 100).
    "provider.bookings.per_month": { access: "limited", limit: 50 },
    "provider.bookings.online": { access: "included" },
    "provider.bookings.buffer_time": { access: "included" },
    "provider.bookings.room_allocation": { access: "included" },
    "provider.booking.embed_widget": { access: "included" },
    "provider.booking.progressive_deposits": { access: "included" },
    "provider.facilities.max": { access: "limited", limit: 3 },
    "provider.service_areas.max": { access: "limited", limit: 1 },
    "provider.appointments.dashboard": { access: "included" },
    "provider.appointments.no_show_shield": { access: "soon" },
    "provider.appointments.no_show_cascade": { access: "included" },
    "provider.patient.history": { access: "included" },
    "provider.patient.reviews_reply": { access: "included" },
    "provider.patient.messaging": { access: "soon" },
    "provider.patient.symptom_router": { access: "included" },
    "provider.clinical.notes_basic": { access: "included" },
    "provider.clinical.ai_soap_notes.per_month": { access: "limited", limit: 100 },
    "provider.clinical.prescriptions_digital": { access: "soon" },
    "provider.clinical.eprescription_sipe": { access: "soon" },
    "provider.video.consultations.per_month": { access: "limited", limit: -1 },
    "provider.video.consultations.online": { access: "included" },
    "provider.video.commission_pct": { access: "limited", limit: 7 },
    "provider.video.commission_cap_eur": { access: "limited", limit: 0 },
    "provider.messaging.sms.per_month": { access: "limited", limit: 50 },
    "provider.messaging.viber.per_month": { access: "limited", limit: 100 },
    "provider.messaging.whatsapp.per_month": { access: "limited", limit: 100 },
    "provider.messaging.push.per_month": { access: "limited", limit: -1 },
    "provider.transaction_fee_pct": { access: "limited", limit: 7 },
    "provider.transaction_fee_cap_eur": { access: "limited", limit: 0 },
    "provider.revenue_dashboard": { access: "soon" },
    "provider.invoice_generation": { access: "soon" },
    "provider.payments.stripe_express_iban": { access: "included" },
    "provider.payments.payout_instant": { access: "included" },
    "provider.wallet.wise_cashout": { access: "included" },
    "provider.analytics.basic": { access: "included" },
    "provider.referral.network": { access: "included" },
    "provider.referral.program_3y": { access: "included" },
    "provider.challenges": { access: "included" },
    "provider.medical_journal": { access: "soon" },
    "provider.cross_border": { access: "included" },
    "provider.white_label_booking_widget": { access: "included" },
    "provider.lifetime_founding": { access: "included" },
    "provider.team.staff_invites": { access: "included" },
    "provider.api_access.calls_per_month": { access: "limited", limit: 0 },
    "provider.security.enforced_2fa": { access: "included" },
    "provider.security.audit_log": { access: "soon" },
    // Legacy parity: this consolidated key replaced google_sync / outlook_sync /
    // caldav_sync / ics_feed / calendar_export / calendar_audit_log, which
    // legacy granted to basic+pro+expert (google) and pro+expert (outlook,
    // caldav) — see src/lib/subscriptions/feature-gate.ts DOCTOR_FEATURE_TIERS.
    // Declaring it only on provider_expert made every pro provider hit a raw
    // 402 the moment they clicked "Connect Google Calendar". Free stays gated,
    // as it was in legacy.
    "provider.calendar.api_audit": { access: "included" },
  },
  provider_expert: {
    "provider.profile.basic": { access: "included" },
    "provider.profile.branded_page": { access: "included" },
    "provider.profile.gallery.photos_max": { access: "limited", limit: -1 },
    "provider.profile.seo_optimization": { access: "included" },
    "provider.profile.multi_locale": { access: "included" },
    "provider.profile.verified_badge": { access: "included" },
    "provider.profile.founding_badge": { access: "included" },
    "provider.schedule.recurring": { access: "included" },
    "provider.schedule.exceptions_holidays": { access: "included" },
    "provider.schedule.multi_location": { access: "included" },
    "provider.schedule.vacation_planner": { access: "included" },
    "provider.schedule.daily_briefing": { access: "included" },
    "provider.bookings.per_month": { access: "limited", limit: -1 },
    "provider.bookings.online": { access: "included" },
    "provider.bookings.buffer_time": { access: "included" },
    "provider.bookings.room_allocation": { access: "included" },
    "provider.booking.embed_widget": { access: "included" },
    "provider.booking.progressive_deposits": { access: "included" },
    "provider.facilities.max": { access: "limited", limit: -1 },
    "provider.service_areas.max": { access: "limited", limit: 5 },
    "provider.appointments.dashboard": { access: "included" },
    "provider.appointments.no_show_shield": { access: "included" },
    "provider.appointments.no_show_cascade": { access: "included" },
    "provider.appointments.no_show_score_per_patient": { access: "included" },
    "provider.appointments.overbooking_ai": { access: "included" },
    "provider.patient.history": { access: "included" },
    "provider.patient.reviews_reply": { access: "included" },
    "provider.patient.messaging": { access: "included" },
    "provider.patient.symptom_router": { access: "included" },
    "provider.clinical.notes_basic": { access: "included" },
    "provider.clinical.ai_soap_notes.per_month": { access: "limited", limit: -1 },
    "provider.clinical.diagnosis_suggestions": { access: "soon" },
    "provider.clinical.prescriptions_digital": { access: "included" },
    "provider.clinical.eprescription_sipe": { access: "soon" },
    "provider.clinical.lab_results_request": { access: "soon" },
    "provider.clinical.icd10_coding_ai": { access: "soon" },
    "provider.clinical.fhir_interop": { access: "soon" },
    "provider.video.consultations.per_month": { access: "limited", limit: -1 },
    "provider.video.consultations.online": { access: "included" },
    "provider.video.recording": { access: "soon" },
    "provider.video.commission_pct": { access: "limited", limit: 5 },
    "provider.video.commission_cap_eur": { access: "limited", limit: 0 },
    "provider.messaging.byop": { access: "included" },
    "provider.messaging.sms.per_month": { access: "limited", limit: 500 },
    "provider.messaging.viber.per_month": { access: "limited", limit: 500 },
    "provider.messaging.whatsapp.per_month": { access: "limited", limit: 500 },
    "provider.messaging.push.per_month": { access: "limited", limit: -1 },
    "provider.transaction_fee_pct": { access: "limited", limit: 5 },
    "provider.transaction_fee_cap_eur": { access: "limited", limit: 0 },
    "provider.revenue_dashboard": { access: "included" },
    "provider.invoice_generation": { access: "included" },
    "provider.payments.stripe_express_iban": { access: "included" },
    "provider.payments.payout_instant": { access: "included" },
    "provider.wallet.wise_cashout": { access: "included" },
    "provider.analytics.basic": { access: "included" },
    "provider.analytics.benchmark": { access: "included" },
    "provider.analytics.conversion_funnel": { access: "soon" },
    "provider.referral.network": { access: "included" },
    "provider.referral.program_3y": { access: "included" },
    "provider.challenges": { access: "included" },
    "provider.medical_journal": { access: "included" },
    "provider.api_access": { access: "soon" },
    "provider.cross_border": { access: "included" },
    "provider.white_label_booking_widget": { access: "included" },
    "provider.lifetime_founding": { access: "included" },
    "provider.team.staff_invites": { access: "included" },
    "provider.branding.advanced": { access: "included" },
    "provider.multi_location_dashboard": { access: "included" },
    "provider.api_access.calls_per_month": { access: "limited", limit: 50000 },
    "provider.calendar.api_audit": { access: "included" },
    "provider.security.enforced_2fa": { access: "included" },
    "provider.security.audit_log": { access: "included" },
  },
  facility_starter: {
    "facility.sub_locations.max": { access: "limited", limit: 2 },
    "facility.staff_users.max": { access: "limited", limit: 3 },
    "facility.doctors_included": { access: "limited", limit: 0 },
    "facility.profile.public_page": { access: "included" },
    "facility.profile.completeness_score": { access: "included" },
    "facility.profile.claim_verify": { access: "included" },
    "facility.profile.multi_locale": { access: "included" },
    "facility.profile.gallery.photos_max": { access: "limited", limit: 2 },
    "facility.profile.seo": { access: "included" },
    "facility.staff.enforced_2fa": { access: "included" },
    "facility.invitation_flows": { access: "included" },
    "facility.doctors.affiliation_roles_4": { access: "included" },
    "facility.doctors.seat_allocation": { access: "included" },
    "facility.calendar.multi_doctor_view": { access: "included" },
    "facility.calendar.color_coding": { access: "included" },
    "facility.crm.campaigns.per_month": { access: "soon" },
    "facility.docs.vault_storage_gb": { access: "limited", limit: 1 },
    "facility.analytics.dashboard": { access: "included" },
    "facility.analytics.export.per_month": { access: "limited", limit: 5 },
    "facility.api.calls_per_month": { access: "limited", limit: 0 },
    "facility.reminders.sms.per_month": { access: "limited", limit: 0 },
    "facility.reminders.viber.per_month": { access: "limited", limit: 0 },
    "facility.reminders.whatsapp.per_month": { access: "limited", limit: 0 },
  },
  facility_professional: {
    "facility.sub_locations.max": { access: "limited", limit: 5 },
    "facility.staff_users.max": { access: "limited", limit: 10 },
    "facility.doctors_included": { access: "limited", limit: 0 },
    "facility.profile.public_page": { access: "included" },
    "facility.profile.completeness_score": { access: "included" },
    "facility.profile.claim_verify": { access: "included" },
    "facility.profile.multi_locale": { access: "included" },
    "facility.profile.gallery.photos_max": { access: "limited", limit: 10 },
    "facility.profile.seo": { access: "included" },
    "facility.staff.roles_6": { access: "included" },
    "facility.staff.enforced_2fa": { access: "included" },
    "facility.invitation_flows": { access: "included" },
    "facility.doctors.affiliation_roles_4": { access: "included" },
    "facility.doctors.seat_allocation": { access: "included" },
    "facility.calendar.multi_doctor_view": { access: "included" },
    "facility.calendar.color_coding": { access: "included" },
    "facility.rooms.management": { access: "included" },
    "facility.checkin.kiosk_qr": { access: "included" },
    "facility.checkin.tv_waiting_room": { access: "included" },
    "facility.queue.live_board": { access: "included" },
    "facility.walkin_tracking": { access: "included" },
    "facility.branding.custom_kiosk_tv": { access: "included" },
    "facility.finance.daily_close": { access: "soon" },
    "facility.finance.revenue_per_doctor": { access: "soon" },
    "facility.finance.outstanding_balances": { access: "soon" },
    "facility.finance.pos_lite": { access: "soon" },
    "facility.finance.insurance_claims_private": { access: "soon" },
    "facility.payments.stripe_express_iban": { access: "included" },
    "facility.finance.reports_bundled": { access: "soon" },
    "facility.crm.patient_db_wide": { access: "soon" },
    "facility.crm.patient_timeline": { access: "included" },
    "facility.crm.follow_up_reminders": { access: "included" },
    "facility.crm.tags_segments": { access: "soon" },
    "facility.crm.campaigns.per_month": { access: "soon" },
    "facility.crm.satisfaction_surveys": { access: "soon" },
    "facility.crm.lead_capture_forms": { access: "soon" },
    "facility.crm.review_management": { access: "included" },
    "facility.docs.vault_storage_gb": { access: "limited", limit: 10 },
    "facility.docs.templates": { access: "soon" },
    "facility.docs.ai_extraction": { access: "soon" },
    "facility.docs.gdpr_consents": { access: "soon" },
    "facility.analytics.dashboard": { access: "included" },
    "facility.analytics.export.per_month": { access: "limited", limit: 50 },
    "facility.analytics.advanced": { access: "included" },
    "facility.api.calls_per_month": { access: "limited", limit: 0 },
    "facility.video.webrtc": { access: "soon" },
    "facility.ai.no_show_shield": { access: "soon" },
    "facility.reminders.sms.per_month": { access: "limited", limit: 200 },
    "facility.reminders.viber.per_month": { access: "limited", limit: 100 },
    "facility.reminders.whatsapp.per_month": { access: "limited", limit: 100 },
    "facility.reminders.byop": { access: "included" },
  },
  facility_enterprise: {
    "facility.sub_locations.max": { access: "limited", limit: -1 },
    "facility.staff_users.max": { access: "limited", limit: -1 },
    "facility.doctors_included": { access: "limited", limit: 0 },
    "facility.profile.public_page": { access: "included" },
    "facility.profile.completeness_score": { access: "included" },
    "facility.profile.claim_verify": { access: "included" },
    "facility.profile.multi_locale": { access: "included" },
    "facility.profile.gallery.photos_max": { access: "limited", limit: 50 },
    "facility.profile.seo": { access: "included" },
    "facility.staff.roles_6": { access: "included" },
    "facility.staff.audit_log": { access: "soon" },
    "facility.staff.sso": { access: "soon" },
    "facility.staff.enforced_2fa": { access: "included" },
    "facility.invitation_flows": { access: "included" },
    "facility.doctors.affiliation_roles_4": { access: "included" },
    "facility.doctors.seat_allocation": { access: "included" },
    "facility.calendar.multi_doctor_view": { access: "included" },
    "facility.calendar.color_coding": { access: "included" },
    "facility.rooms.management": { access: "included" },
    "facility.checkin.kiosk_qr": { access: "included" },
    "facility.checkin.tv_waiting_room": { access: "included" },
    "facility.queue.live_board": { access: "included" },
    "facility.walkin_tracking": { access: "included" },
    "facility.branding.custom_kiosk_tv": { access: "included" },
    "facility.finance.daily_close": { access: "included" },
    "facility.finance.revenue_per_doctor": { access: "included" },
    "facility.finance.outstanding_balances": { access: "included" },
    "facility.finance.pos_lite": { access: "included" },
    "facility.finance.insurance_claims_private": { access: "included" },
    "facility.finance.insurance_claims_cnas": { access: "soon" },
    "facility.payments.stripe_express_iban": { access: "included" },
    "facility.finance.reports_bundled": { access: "included" },
    "facility.crm.patient_db_wide": { access: "included" },
    "facility.crm.patient_timeline": { access: "included" },
    "facility.crm.follow_up_reminders": { access: "included" },
    "facility.crm.tags_segments": { access: "included" },
    "facility.crm.campaigns.per_month": { access: "soon" },
    "facility.crm.satisfaction_surveys": { access: "included" },
    "facility.crm.lead_capture_forms": { access: "included" },
    "facility.crm.review_management": { access: "included" },
    "facility.docs.vault_storage_gb": { access: "limited", limit: -1 },
    "facility.docs.templates": { access: "included" },
    "facility.docs.ai_extraction": { access: "included" },
    "facility.docs.esignature_eidas": { access: "soon" },
    "facility.docs.gdpr_consents": { access: "included" },
    "facility.chain.dashboard_kpi": { access: "soon" },
    "facility.chain.brand_enforcement": { access: "soon" },
    "facility.chain.centralized_billing": { access: "soon" },
    "facility.referral.cross_clinic": { access: "included" },
    "facility.support.priority_4h": { access: "included" },
    "facility.support.account_manager": { access: "included" },
    "facility.hr.shift_scheduling": { access: "soon" },
    "facility.hr.attendance_tracking": { access: "soon" },
    "facility.hr.leave_management": { access: "soon" },
    "facility.hr.payroll_prep": { access: "soon" },
    "facility.inventory.stock": { access: "soon" },
    "facility.inventory.low_stock_alerts": { access: "soon" },
    "facility.inventory.usage_per_procedure": { access: "soon" },
    "facility.analytics.dashboard": { access: "included" },
    "facility.analytics.benchmark_anon": { access: "included" },
    "facility.analytics.custom_reports": { access: "soon" },
    "facility.analytics.export.per_month": { access: "limited", limit: -1 },
    "facility.analytics.advanced": { access: "included" },
    "facility.analytics.forecasting": { access: "included" },
    "facility.api.access": { access: "soon" },
    "facility.api.calls_per_month": { access: "soon" },
    "facility.integrations.pms_import": { access: "soon" },
    "facility.integrations.fhir": { access: "soon" },
    "facility.white_label_portal": { access: "soon" },
    "facility.video.webrtc": { access: "included" },
    "facility.ai.phone_assistant": { access: "soon" },
    "facility.ai.no_show_shield": { access: "included" },
    "facility.automation.marketing_journeys": { access: "soon" },
    "facility.reminders.sms.per_month": { access: "limited", limit: 2000 },
    "facility.reminders.viber.per_month": { access: "limited", limit: 1000 },
    "facility.reminders.whatsapp.per_month": { access: "limited", limit: 1000 },
    "facility.reminders.byop": { access: "included" },
  },
  business_free: {
    "business.profile.listing_public_data": { access: "included" },
    "business.profile.gallery.photos_max": { access: "limited", limit: 0 },
    "business.landing_pages.max": { access: "limited", limit: 0 },
    "business.referral_partnership": { access: "included" },
    "business.messaging.sms.per_month": { access: "limited", limit: 0 },
  },
  business_basic: {
    "business.profile.full_editable": { access: "included" },
    "business.profile.contact_multi": { access: "included" },
    "business.profile.opening_hours": { access: "included" },
    "business.profile.accessibility": { access: "included" },
    "business.profile.languages_support": { access: "included" },
    "business.profile.reviews_reply": { access: "included" },
    "business.profile.gallery.photos_max": { access: "limited", limit: 5 },
    "business.profile.seo": { access: "included" },
    "business.landing_pages.max": { access: "soon" },
    "business.leads.dashboard": { access: "soon" },
    "business.analytics.views_conversions": { access: "included" },
    "business.referral_partnership": { access: "included" },
    "business.messaging.sms.per_month": { access: "limited", limit: 0 },
  },
  business_pro: {
    "business.profile.full_editable": { access: "included" },
    "business.profile.contact_multi": { access: "included" },
    "business.profile.opening_hours": { access: "included" },
    "business.profile.accessibility": { access: "included" },
    "business.profile.languages_support": { access: "included" },
    "business.profile.reviews_reply": { access: "included" },
    "business.profile.branded_page": { access: "included" },
    "business.profile.services_catalog": { access: "included" },
    "business.profile.gallery.photos_max": { access: "limited", limit: -1 },
    "business.profile.seo": { access: "included" },
    "business.multi_specialty": { access: "included" },
    "business.cross_border_services": { access: "included" },
    "business.staff_doctors": { access: "included" },
    "business.landing_pages.max": { access: "limited", limit: -1 },
    "business.search.priority": { access: "included" },
    "business.search.claim_verify": { access: "included" },
    "business.reminders.automated": { access: "included" },
    "business.insurance_display": { access: "included" },
    "business.multi_location": { access: "included" },
    "business.hours.custom_holidays": { access: "included" },
    "business.leads.dashboard": { access: "included" },
    "business.leads.crm_pipeline": { access: "included" },
    "business.analytics.views_conversions": { access: "included" },
    "business.referral_partnership": { access: "included" },
    "business.api_access": { access: "soon" },
    "business.white_label": { access: "soon" },
    "business.messaging.sms.per_month": { access: "soon" },
    "business.pharmacy.online_orders": { access: "soon" },
    "business.lab.slot_booking": { access: "soon" },
  },
};

export const PLAN_CODES = [
  "user_free",
  "user_plus",
  "provider_free",
  "provider_pro",
  "provider_expert",
  "facility_starter",
  "facility_professional",
  "facility_enterprise",
  "business_free",
  "business_basic",
  "business_pro",
] as const;

export type PlanCode = (typeof PLAN_CODES)[number];
